export default __webpack_public_path__ + "static/media/discord-circ.819187e1.svg";